"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDropDown = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../common");
const constants_1 = require("../constants");
exports.ContentDropDown = react_1.default.memo(({ typeList, setFilterMenu, }) => {
    const [choiceTab, setChoiceTab] = react_1.default.useState(constants_1.CONTENTS_DROP_DEFAULT);
    const handlerDropDown = value => {
        setChoiceTab(value);
    };
    (0, react_1.useEffect)(() => {
        if (choiceTab.id === 'all') {
            setFilterMenu(typeList);
        }
        else {
            setFilterMenu([choiceTab.id]);
        }
    }, [choiceTab]);
    const list = (0, react_1.useMemo)(() => constants_1.CONTENTS_DROP_LIST.filter(item => item.id !== 'all' ? typeList.includes(item.id) : item), [typeList]);
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-live", list: list, value: choiceTab, setDropValue: handlerDropDown }));
});
